import { Box, Popper, Button, Paper, Divider } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import React, { useState, useEffect } from "react";
import "../../styles/ListingPageFilter.css";
import {
  filterByRadius,
  sortByList,
  sortByUserList,
} from "../../data/PackageListing";
import { getStorageValue } from "../../utils/helper";
import AlertMessage from "./AlertMessage";

const ListingPageFilter = ({
  type,
  applyFilter,
  sortList,
  defaultValue,
  defaultFilterValue,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-filter-popper" : undefined;
  const [filterVal, setFilterVal] = useState(
    defaultFilterValue ? defaultFilterValue : ""
  );
  const [sortVal, setSortVal] = useState(defaultValue ? defaultValue : "");
  const [appliedValue, setAppliedValue] = useState({
    sortedValue: localStorage.getItem("SortByParams")
      ? localStorage.getItem("SortByParams")
      : defaultValue
      ? defaultValue
      : "",
    filteredValue: localStorage.getItem("FilterParams")
      ? localStorage.getItem("FilterParams")
      : defaultFilterValue
      ? defaultFilterValue
      : "",
  });
  const sortListMap = sortList === "package" ? sortByList : sortByUserList;
  const CurrentLatitude = getStorageValue("latitude");
  const CurrentLongitude = getStorageValue("longitude");
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("");
  const handleClose = () => {
    setAlertSeverity("");
    setAlertMessage("");
    setOpenAlert(false);
  };

  useEffect(() => {
    setSortVal(defaultValue);
  }, [defaultValue]);

  const handlePopperClick = (event) => {
    setFilterVal(
      appliedValue?.filteredValue
        ? appliedValue?.filteredValue
        : defaultFilterValue
    );
    setSortVal(
      appliedValue?.sortedValue ? appliedValue?.sortedValue : defaultValue
    );
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const getSortBy = () => {
    switch (appliedValue?.sortedValue) {
      case "0":
        return "All";
      case "1":
        return "Requester";
      case "2":
        return "Delivery Person";
      default:
        return "All";
    }
  };

  const getPackageSortBy = () => {
    switch (appliedValue?.sortedValue) {
      case "1":
        return "Expiry Date";
      case "2":
        return "Origin";
      case "3":
        return "Destination";
      default:
        return "Expiry Date";
    }
  };

  const getPackageFilterBy = () => {
    switch (appliedValue?.filteredValue) {
      case "All":
        return "All";
      case "50":
        return "50";
      case "100":
        return "100";
      case "150":
        return "150";
      case "200":
        return "200";
      case "250":
        return "250";
      default:
        return "All";
    }
  };

  return (
    <Box>
      {sortList === "package" && type === 1 && (
        <Button
          className="open-filter-btn filter-button button-background"
          type="button"
          disabled
        >
          <Box className="filter-label">
            Radius |{" "}
            <span className="selected-filter">{getPackageFilterBy()}</span>
          </Box>
        </Button>
      )}
      <Button
        className="open-filter-btn filter-button button-background"
        type="button"
        disabled
      >
        <Box className="filter-label">
          Sort by |{" "}
          <span className="selected-filter">
            {sortList !== "package" ? getSortBy() : getPackageSortBy()}
          </span>
        </Box>
      </Button>
      <Button
        className="open-filter-btn filter-button"
        type="button"
        onClick={handlePopperClick}
      >
        <img
          src={require("../../assets/logos/filter-icon.svg").default}
          width="20px"
          height="20px"
          alt="filterIcon"
        />
        <span
          style={{
            fontSize: "14px",
            fontWeight: "600",
            color: "#344054",
            lineHeight: 1,
          }}
        >
          Filters
        </span>
      </Button>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        className="filter-box"
      >
        <Paper elevation={2} sx={{ width: "320px" }}>
          <Box
            sx={{
              padding: "12px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <img
                src={require("../../assets/logos/filter-icon.svg").default}
                width="20px"
                height="20px"
                alt="filterIcon"
              />
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344054",
                }}
              >
                Filters
              </span>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box>
              {type === 1 && (
                <div style={{ marginBottom: "1rem" }}>
                  <h6
                    style={{
                      margin: "unset",
                      fontSize: "12px",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                    }}
                  >
                    Radius in miles
                  </h6>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "justify-start",
                      gap: "5px",
                      marginTop: "3px",
                    }}
                  >
                    {filterByRadius.map((filter, index) => (
                      <Button
                        key={index}
                        sx={{
                          border: "1px solid #a6adb7",
                          color: filter === filterVal ? "white" : "black",
                          fontSize: "14px",
                          textTransform: "none",
                          minWidth: "20px",
                          minHeight: "15px",
                          fontWeight: "500",
                          backgroundColor:
                            filter === filterVal ? "#0C68F4" : "",
                        }}
                        size="small"
                        variant="outlined"
                        value={filter}
                        onClick={(e) => {
                          if(e.target.value !== "All" && !CurrentLatitude && !CurrentLongitude) {
                            setAlertSeverity("error");
                            setAlertMessage("Please enable the location to use radius filter.");
                            setOpenAlert(true);
                          } else{
                            setFilterVal(e.target.value)
                          }
                        }}
                      >
                        {filter}
                      </Button>
                    ))}
                  </Box>
                </div>
              )}
              <div>
                <h6
                  style={{
                    margin: "unset",
                    fontSize: "12px",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                  }}
                >
                  Sort By
                </h6>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "justify-start",
                    gap: "5px",
                    marginTop: "3px",
                  }}
                >
                  {sortListMap.map((sort) => (
                    <Button
                      key={sort.id}
                      sx={{
                        border: "1px solid #a6adb7",
                        color: sort.id === sortVal ? "white" : "black",
                        fontSize: "14px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        textTransform: "none",
                        minWidth: "40px",
                        minHeight: "30px",
                        fontWeight: "500",
                        backgroundColor: sort.id === sortVal ? "#0C68F4" : "",
                      }}
                      size="small"
                      variant="outlined"
                      value={sort.id}
                      endIcon={sort.id === sortVal ? <DoneIcon /> : ""}
                      onClick={(e) => setSortVal(e.target.value)}
                    >
                      {sort.value}
                    </Button>
                  ))}
                </Box>
              </div>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "8px",
              }}
            >
              <Button
                type="button"
                onClick={handlePopperClick}
                className="filter-cancel-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  applyFilter({
                    miles: filterVal === "All" ? "" : filterVal,
                    sortBy: sortVal,
                  });
                  setAppliedValue({
                    ...appliedValue,
                    sortedValue: sortVal,
                    filteredValue: filterVal,
                  });
                  localStorage.setItem("FilterParams", filterVal);
                  localStorage.setItem("SortByParams", sortVal);
                  setAnchorEl(null);
                }}
                className="filter-apply-btn"
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Paper>
      </Popper>
      <AlertMessage
          open={openAlert}
          handleClose={handleClose}
          message={alertMessage}
          severity={alertSeverity}
        />
    </Box>
  );
};

export default ListingPageFilter;
